<script setup>
import { useChatStore } from '@/stores/chat'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

const chatStore = useChatStore()

const {
  messageToReply
} = storeToRefs(chatStore)

const imagePreview = computed(() => {
  if (messageToReply.value?.attachment) {
    return messageToReply.value.attachment.fields.links.c160x160
  } else if (messageToReply.value?.post) {
    return messageToReply.value?.post.previewImageUrl
  } else {
    return null
  }
})

function scrollToReply () {
  const messageId = messageToReply.value?.messageId
  if (!messageId) return

  const element = document.getElementById(messageId)
  if (!element) return

  element.scrollIntoView({ behavior: 'smooth', block: 'center' })

  element.classList.add('shake-reply')

  setTimeout(() => {
    element.classList.remove('shake-reply')
  }, 600)
}
</script>

<template>
  <transition name="fade">
    <div
      v-if="messageToReply"
      class="bg-white rounded-t-lg border-t border-gray-100 p-1 cursor-pointer"
      @click="scrollToReply">
      <div class="flex gap-2 items-center justify-between p-3 bg-gray-100 rounded-t-[0.438rem]">
        <InlineSvg
          :src="require('@/assets/fontawesome/regular/arrow-turn-down-right.svg')"
          class="w-4 h-4 shrink-0 text-gray-500"/>

        <div class="flex gap-2 w-full overflow-auto! h-30">
          <img
            v-if="imagePreview"
            :src="imagePreview"
            class="w-10 h-10 object-cover rounded"
            alt="">

          <p class="text-sm text-gray-500">
            "{{ messageToReply.text }}"
          </p>
        </div>

        <button
          type="button"
          class="p-1 -mr-1"
          @click.stop="messageToReply = null">
          <InlineSvg
            :src="require('@/assets/svg/design/cross.svg')"
            class="w-3.5 h-3.5 text-gray-500"/>
        </button>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  :global(.shake-reply) {
    animation: shake 0.5s ease;
  }

  @keyframes shake {
    0%, 100% {
      transform: translateX(0);
    }
    15% {
      transform: translateX(-4px);
    }
    30% {
      transform: translateX(4px);
    }
    45% {
      transform: translateX(-3px);
    }
    60% {
      transform: translateX(3px);
    }
    75% {
      transform: translateX(-1px);
    }
    90% {
      transform: translateX(1px);
    }
  }
</style>
